import Controller from '@ember/controller';
import { action } from '@ember/object';
import { service } from '@ember/service';
import { tracked } from '@glimmer/tracking';

export default class SettingsCustomersListController extends Controller {
  @service store;
  @service intl;

  queryParams = ['search'];
  @tracked search = '';

  get customers() {
    let customers = this.model;

    if (this.search) {
      customers = customers.filter((customer) => {
        return (customer.name ?? '')
          .toLowerCase()
          .includes(this.search.toLowerCase());
      });
    }

    return customers;
  }

  @action
  deleteCustomer(customer) {
    customer.destroyRecord();
  }
}
